import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import AvatarGroup from '@atlaskit/avatar-group';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import Skeleton from '@atlaskit/skeleton';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import { useContentContributors } from '../hooks/useContentContributors';

import { InlineRetryError } from './InlineRetryError';
import { DetailRow } from './DetailRow';

const i18n = defineMessages({
	contributors: {
		id: 'details-panel.contributor-row.contributors',
		defaultMessage: 'Contributors',
		description: "A title that accompanies a list of the content's contributors",
	},
});

const noop = () => {};

export const ContributorsRow = () => {
	const { formatMessage } = useIntl();
	const { data, error, refetch, loading } = useContentContributors();
	const { nodes } = data;
	const safeNodes = nodes ?? [];

	if (safeNodes.length === 0 && !error) return null;

	const nodesWithAnalyticsContext = safeNodes.map((node) => ({
		...node,
		/* an analytics event is only fired if onClick is provided,
			 but providing onClick will change behavior if href is not provided */
		onClick: node.href ? noop : undefined,
		analyticsContext: {
			source: 'contentWrapper',
			attributes: { role: 'contributor', name: 'profileImage' },
		},
	}));

	const renderContributorsSectionContent = () => {
		if (loading) {
			return (
				<UFOLoadHold name="contributors-row-details-panel-hold">
					<Skeleton width="80px" height="24px" borderRadius={3} testId="contributors-row-loading" />
				</UFOLoadHold>
			);
		}

		if (error) {
			return <InlineRetryError error={error} refetch={refetch} />;
		}

		return (
			<AvatarGroup size="small" maxCount={3} appearance="stack" data={nodesWithAnalyticsContext} />
		);
	};

	return (
		<DetailRow itemName={formatMessage(i18n.contributors)} icon={<PeopleGroupIcon label="" />}>
			{renderContributorsSectionContent()}
		</DetailRow>
	);
};
